export type ViewShareRow = { lifetime_views?: number | null };

const knownViews = (value: number | null | undefined) => (
  typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null
);

/**
 * Adds each row's share (0–1) of the selection's known lifetime views and orders rows by views,
 * unknown views last. The share is null when a row's views are unknown or the total is 0.
 */
export function computeViewShares<T extends ViewShareRow>(rows: readonly T[]): Array<T & { share: number | null }> {
  const total = rows.reduce((sum, row) => sum + (knownViews(row.lifetime_views) ?? 0), 0);
  return rows
    .map((row) => {
      const views = knownViews(row.lifetime_views);
      return { ...row, share: views !== null && total > 0 ? views / total : null };
    })
    .sort((a, b) => (knownViews(b.lifetime_views) ?? -1) - (knownViews(a.lifetime_views) ?? -1));
}
